import React from 'react';

export interface PaginatedSelectContextValue {
  mode: 'single' | 'multiple';
  enableSearch: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  value: string | string[];
  onValueChange: (value: string) => void;
  search: string;
  setSearch: (search: string) => void;
  items: Array<Record<string, unknown>>;
  setItems: (items: Array<Record<string, unknown>>) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  isFetchingMore: boolean;
  setIsFetchingMore: (fetching: boolean) => void;
  hasMore: boolean;
  setHasMore: (hasMore: boolean) => void;
  page: number;
  setPage: (page: number) => void;
  pageSize: number;
  renderItem?: (item: Record<string, unknown>) => {
    value: string;
    label: string;
    disabled?: boolean;
  };
  error: string;
  disabled: boolean;
  name?: string;
  control?: unknown;
  rules?: unknown;
  label?: string;
  placeholder?: string;
  helperText?: string;
  isSelected: (itemValue: string) => boolean;
  onLoadMore: () => void;
}

export const PaginatedSelectContext = React.createContext<PaginatedSelectContextValue | undefined>(
  undefined,
);
